"use strict";

exports.__esModule = true;
exports.default = void 0;

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));

var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));

var _DialogContentText = _interopRequireDefault(require("@material-ui/core/DialogContentText"));

var _DialogTitle = _interopRequireDefault(require("@material-ui/core/DialogTitle"));

var _react = _interopRequireDefault(require("react"));

var _Slide = _interopRequireDefault(require("@material-ui/core/Slide"));

var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));

var _reactIntl = require("react-intl");

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Transition = _react.default.forwardRef(function (props, ref) {
  return /*#__PURE__*/_react.default.createElement(_Slide.default, _extends({
    direction: "up"
  }, props, {
    ref: ref
  }));
});

var QuestionDialog = function QuestionDialog(_ref) {
  var _ref$isProcessing = _ref.isProcessing,
      isProcessing = _ref$isProcessing === void 0 ? false : _ref$isProcessing,
      _ref$isOpen = _ref.isOpen,
      isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? '' : _ref$id,
      _ref$message = _ref.message,
      message = _ref$message === void 0 ? '' : _ref$message,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      _ref$action = _ref.action,
      action = _ref$action === void 0 ? '' : _ref$action,
      _ref$handleAction = _ref.handleAction,
      handleAction = _ref$handleAction === void 0 ? function () {} : _ref$handleAction,
      _ref$handleClose = _ref.handleClose,
      handleClose = _ref$handleClose === void 0 ? function () {} : _ref$handleClose,
      rest = _objectWithoutPropertiesLoose(_ref, ["isProcessing", "isOpen", "id", "message", "title", "action", "handleAction", "handleClose"]);

  var intl = (0, _reactIntl.useIntl)();
  var theme = (0, _styles.useTheme)();
  var fullScreen = (0, _useMediaQuery.default)(theme.breakpoints.down('sm'));
  return /*#__PURE__*/_react.default.createElement(_Dialog.default, _extends({
    fullScreen: fullScreen,
    open: isOpen,
    onClose: handleClose,
    TransitionComponent: Transition,
    "aria-labelledby": "alert-dialog-title",
    "aria-describedby": "alert-dialog-description"
  }, rest), /*#__PURE__*/_react.default.createElement(_DialogTitle.default, {
    id: "alert-dialog-title"
  }, title), /*#__PURE__*/_react.default.createElement(_DialogContent.default, null, /*#__PURE__*/_react.default.createElement(_DialogContentText.default, {
    id: "alert-dialog-description"
  }, message)), /*#__PURE__*/_react.default.createElement(_DialogActions.default, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: handleClose,
    color: "primary"
  }, intl.formatMessage({
    id: 'cancel',
    defaultMessage: 'Cancel'
  })), /*#__PURE__*/_react.default.createElement(_Button.default, {
    disabled: isProcessing,
    onClick: function onClick() {
      handleAction(handleClose);
    },
    color: "secondary"
  }, action)));
};

var _default = QuestionDialog;
exports.default = _default;
module.exports = exports.default;